import { configureStore, Middleware } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { localAppStorage } from './local-storage';
import { Api } from '../api/root-api';
import { userSlice } from '../auth';
import { workspaceSlice } from '../workspace';
import appReducer from './appReducer';
import { inviteSlice } from '../invite';
import { getAppVersion, updateAppVersion } from '../user-preference';
import { resetTableConfig, tableConfigSlice } from '../table-config';
import { customersSlice } from '../customers';
import { divisionSlice } from '../division/slice';
import { configSlice } from '../config';
import { tripSlice } from '../trip';
import { tourSlice } from '../tour/slice';
import { jtbdTourSlice } from '../jtbd-3.0';
import { signupJTBDSlice } from '../signup-jtbd';
import { commonDataSlice } from '../common';
import { isWeb } from '@zonofi/common';
import { customerContactSlice } from '../customer-contact/slice';

// ✅ Redux Persist Config
const persistConfig = {
  key: 'root',
  storage: localAppStorage,
  whitelist: [
    userSlice.name,
    workspaceSlice.name,
    inviteSlice.name,
    tableConfigSlice.name,
    customersSlice.name,
    divisionSlice.name,
    configSlice.name,
    tripSlice.name,
    tourSlice.name,
    customerContactSlice.name,
    jtbdTourSlice.name,
    signupJTBDSlice.name,
    commonDataSlice.name,
  ],
  blacklist: [Api.reducerPath],
  timeout: 10000,
};

// ✅ Root reducer with logout reset
const rootReducer = (state: any, action: any) => {
  if (action.type === 'userAuth/logOut') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const pReducer = persistReducer(persistConfig, rootReducer);

// ✅ App Version Middleware
const checkVersionMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action);
  const appVersion = getAppVersion(store.getState());
  // const version = process.env['VERSION'];
  // if (version && appVersion !== version) {
  //   console.log('versionUpdated', version);
  //   store.dispatch(updateAppVersion(version));
  //   store.dispatch(resetTableConfig());
  // }
  return result;
};

// ✅ Middleware Setup - keep it simple
const middlewares: Middleware[] = [Api.middleware, checkVersionMiddleware];

// ✅ Create enhancers with Reactotron
const createEnhancers = (getDefaultEnhancers: any) => {
  return getDefaultEnhancers();
};

// ✅ Configure Redux Store
const reduxStore = configureStore({
  reducer: pReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  ...(!isWeb() ? { enhancers: createEnhancers } : {}),
  devTools: __DEV__,
});

// ✅ Exports
export const store = reduxStore;
export const persistor = persistStore(reduxStore);
export const dispatch = reduxStore?.dispatch;
